import { useTranslation } from "react-i18next";

const Check = () => (<svg width="163px" height="163px" viewBox="0 0 163 163">
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Artboard" transform="translate(-29.000000, -29.000000)" fill="#fff">
          <g id="Group" transform="translate(29.000000, 29.000000)">
              <circle id="Oval" stroke="#fff" strokeWidth="6" fillOpacity="0.1698809" cx="81.5" cy="81.5" r="78.5"></circle>
              <path d="M70.9943717,116.593669 C70.097083,117.496358 68.8728684,118 67.6011967,118 C66.329525,118 65.1053104,117.496358 64.2080217,116.593669 L37.1091997,89.486641 C34.2969334,86.6739792 34.2969334,82.1130724 37.1091997,79.3056845 L40.5023747,75.9111531 C43.3155199,73.0984913 47.8705123,73.0984913 50.6827786,75.9111531 L67.6011967,92.8328297 L113.317221,47.1094963 C116.130366,44.2968346 120.689753,44.2968346 123.497625,47.1094963 L126.8908,50.5040277 C129.703067,53.3166895 129.703067,57.8767172 126.8908,60.6849842 L70.9943717,116.593669 Z" id="Path" fillRule="nonzero"></path>
          </g>
      </g>
  </g>
</svg>)

export default function StepProgress({steps, currentStep}) {
	const { t } = useTranslation();
  
  return (
  <div className="test-status">
    {/* <h2>{t("TEST STATUS")}</h2> */}
    <div className="step-progress">
      {steps.map((step, index) => (
        <div key={step.id} className="step-item">
          <div className={`step-circle ${step.completed ? 'completed' : ''} ${step.id === currentStep ? 'current' : ''}`}>
            {step.completed ? <Check style={{ fill: '#fff !important' }}/> : step.id}
          </div>
          <div className="step-label">{step.label}</div>
          {index < steps.length - 1 && (
            <div className={`step-line ${step.completed ? 'completed' : ''}`}></div>
          )}
        </div>
      ))}
    </div>
  </div>
  )
}